module.exports = __webpack_public_path__ + "img/recursion.0e0f88c8.svg";